import COUNTRIES from '../countries.translations'

import translations from './cadmium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/cadmium'

export const cadmium: Metal = {
  id: 24,
  slug: 'cadmium',
  name: t.name,
  symbol: 'Cd',
  // Processing facilities, not mines; coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Zhuzhou, cadmium processing facility (China)',
      region: t.mine0Region,
      slug: 'zhuzhou',
      coordinates: [113.13, 27.83],
    },
    {
      name: 'Huludao, cadmium processing facility (China)',
      region: t.mine1Region,
      slug: 'huludao',
      coordinates: [120.84, 40.71],
    },
    {
      name: 'Onsan, cadmium processing facility (South Korea)',
      region: t.mine2Region,
      slug: 'onsan',
      coordinates: [129.36, 35.43],
    },
    {
      name: 'Akita, cadmium processing facility (Japan)',
      region: t.mine3Region,
      slug: 'akita',
      coordinates: [140.1, 39.72],
    },
    {
      name: 'Trail, cadmium processing facility (Canada)',
      region: t.mine4Region,
      slug: 'trail',
      coordinates: [-117.71, 49.1],
    },
    {
      name: 'San Luis Potosí, cadmium processing facility (Mexico)',
      region: t.mine5Region,
      slug: 'san-luis-potosi',
      coordinates: [-100.98, 22.15],
    },
    {
      name: 'Ust-Kamenogorsk, cadmium processing facility (Kazakhstan)',
      region: t.mine6Region,
      slug: 'ust-kamenogorsk',
      coordinates: [82.61, 49.95],
    },
  ],
  // Refining shares, not mine production — see the `**` footnote.
  countries: [
    { name: COUNTRIES.china, percent: 38.8 },
    { name: COUNTRIES.southKorea, percent: 18.8 },
    { name: COUNTRIES.japan, percent: 7.1 },
    { name: COUNTRIES.canada, percent: 7.1 },
    { name: COUNTRIES.mexico, percent: 5 },
  ],
  // Recovered from zinc refining, never mined for itself.
  related: ['zinc'],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 1, ...t.impacts.human },
      geopolitical: { severity: 2, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: null, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
          credit: 'CFOTO / Getty',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
          credit: 'Bloomberg / Getty',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'vertical',
        },
      ],
    },
  },
}
